import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-truck-tracker',
  templateUrl: './truck-tracker.component.html',
  styleUrls: ['./truck-tracker.component.scss']
})
export class TruckTrackerComponent implements OnInit, AfterViewInit, OnDestroy {

  token = '';
  requestId = '';

  isLoading = false;

  dashCamGpsDeviceId = '';

  trackingDetails: any;

  truckUnitNumber = 102;

  markers: (google.maps.MarkerOptions & { data: any })[] = [];

  lastQueryPositionTime: any;

  timeoutRef?: any;

  options: google.maps.MapOptions = {
    zoom: 2
  };
  showInfo = false;

  toggleInfo() {
    this.showInfo = !this.showInfo;
  }

  truckSymbol: google.maps.Symbol = {
    path: 'M96.88 74.97a14.325 14.325 0 1 0 14.33 14.32 14.34 14.34 0 0 0-14.33-14.32zm0 22.127a7.8 7.8 0 1 1 7.805-7.8A7.814 7.814 0 0 1 96.88 97.1zM116.78 71.545a1.489 1.489 0 0 0 1.485 1.485h2.725v-2.97h-2.725a1.489 1.489 0 0 0-1.485 1.485zM36.643 85.487a3.805 3.805 0 1 0 3.805 3.805 3.809 3.809 0 0 0-3.805-3.805z M36.64 74.97a14.325 14.325 0 1 0 14.33 14.32 14.331 14.331 0 0 0-14.33-14.32zm0 22.127a7.8 7.8 0 1 1 7.805-7.8 7.813 7.813 0 0 1-7.802 7.803zM96.88 85.487a3.805 3.805 0 1 0 3.805 3.805 3.809 3.809 0 0 0-3.805-3.805zM16.48 71.545A1.489 1.489 0 0 0 15 70.06H7.01v2.97H15a1.489 1.489 0 0 0 1.48-1.485z M95.28 24.38H72.02a3.267 3.267 0 0 0-3.26 3.26v23.67a5.158 5.158 0 0 1-5.15 5.16H10.27a3.261 3.261 0 0 0-3.26 3.26v6.33h8.16a5.32 5.32 0 0 1 5.31 5.31v.35a5.326 5.326 0 0 1-5.31 5.31H7.01v7a3.261 3.261 0 0 0 3.26 3.26h8.16a18.325 18.325 0 0 1 36.43 0h23.8a18.331 18.331 0 0 1 36.44 0h2.63a3.261 3.261 0 0 0 3.26-3.26v-7h-2.9a5.326 5.326 0 0 1-5.31-5.31v-.35a5.32 5.32 0 0 1 5.31-5.31h2.9V50.09a25.741 25.741 0 0 0-25.71-25.71zm19.193 26.931a5.162 5.162 0 0 1-5.157 5.156H80.438a5.162 5.162 0 0 1-5.156-5.156V36.059a5.162 5.162 0 0 1 5.156-5.159h14.845a19.212 19.212 0 0 1 19.19 19.19z M95.283 34.9H80.438a1.157 1.157 0 0 0-1.156 1.156v15.255a1.157 1.157 0 0 0 1.156 1.156h28.878a1.158 1.158 0 0 0 1.157-1.156v-1.218A15.207 15.207 0 0 0 95.283 34.9z', // A simplified truck shape
    fillColor: '#f86c6b ',
    fillOpacity: 1,
    strokeColor: '#f86c6b ',
    strokeWeight: 0.1,
    scale: 0.25,
  };

  constructor(private readonly route: ActivatedRoute, private http: HttpClient) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    const queryParams = this.route.snapshot.queryParams;
    this.token = queryParams['token'];
    this.requestId = queryParams['requestId'];
    this.getTrackingDetails();
  }

  ngAfterViewInit() {
    this.timeoutRef = setTimeout(() => {
      this.getTrackingDetails(this.lastQueryPositionTime);
    }, 10000)
  }

  private getTrackingDetails(lastQueryPositionTime?: any): void {
    // Get Tracking data
    let url = environment.trucksurl + '/getTruckLocationByLink';
    const params = {token: this.token, requestId: this.requestId}
    if(lastQueryPositionTime) {
      params['lastQueryPositionTime'] = lastQueryPositionTime;
    }
    this.http.get(url, {params: params})
    .subscribe({
      next: response => {
        console.log('response', response);
        this.lastQueryPositionTime = response['lastQueryPositionTime']
        this.trackingDetails = response['truckData'];
        this.markers = this.trackingDetails.map(data => ({
          icon: this.truckSymbol,
          position: new google.maps.LatLng(data.lastPosition.callat, data.lastPosition.callon),
          data: {
            truckId: data.id,
            deviceId: data.dashCamGpsDeviceId,
            unitNumber: data.truckUnitNumber,
            lastUpdate: data.lastPosition?.updatetime
          },
          title: data.truckUnitNumber
        }));
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        console.log('Error getting tracking details', error);
      }
    });

  }
  ngOnDestroy() {
    if(this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
  }
}
